export default {"src":"/_next/static/media/arrow.f591bcbb.svg","height":18,"width":10,"blurWidth":0,"blurHeight":0};